import { useEffect, useState } from "react";
import logo from "../../assets/01pos.webp";

function MobileBlocker({ children }) {
  const [isMobile, setIsMobile] = useState(false);

  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent));

  useEffect(() => {
    const mql = window.matchMedia("(max-width: 1023px)");

    const onChange = () => setIsMobile(mql.matches);

    mql.addEventListener("change", onChange);
    setIsMobile(mql.matches);

    return () => mql.removeEventListener("change", onChange);
  }, []);

  if (isMobile && !isIOS) {
    return (
      <div className="min-h-screen bg-customBlue flex flex-col justify-center items-center px-6 text-center gap-6">
        <img src={logo} alt="01POS" className="w-32" />
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-sm w-full flex flex-col items-center gap-2">
          <p className="text-gray-600 text-sm leading-relaxed">
            This feature doesn't work on mobile browser. Please use our mobile
            app instead.
          </p>

          <a
            href="https://play.google.com/store/apps/details?id=com.onetech.posapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              className="w-48 mx-auto h-16"
            />
          </a>
        </div>
      </div>
    );
  }

  return children;
}

export default MobileBlocker;
